<template>
  <div class="flex flex-col space-y-3 group">
    <div v-if="titlePosition == 'top'" class="flex flex-col blog-publish">
      <div class="mb-[1.071rem]">
        <Heading
          :level="1"
          size="xl"
          color="text-ash-200"
        >
          {{ article?.title }}
        </Heading>
      </div>
      <ArticleMeta
        :publishAt="article.publishAt ?? undefined"
        :authorName="article.authorName ?? undefined"
        :isFeatured="false"
        :titlePos="titlePosition ?? 'bottom'"
      />
    </div>
      <div v-if="mediaType !== 'video'"
      class="relative overflow-hidden transition-all duration-200 ease-in-out mb-[0.142857rem] p-[1.5rem] lg:p-0 focus-element"
      :class="{
        'group-hover:shadow-[0.714rem_0.714rem_1.143rem_-0.429rem_var(--color-gray-600)] h-[16.071rem] rounded-[0.5714285714rem] ':
          titlePosition === 'bottom',
        'h-[13.393rem] md:h-[39.295rem] mt-[1.7857rem]':
          titlePosition === 'top',
        'rounded-[0.4285714286rem] shadow-[0_0.0625rem_0.125rem_0_var(--color-gray-600)] !h-[20rem]': mediaType === 'podcast'
      }"
      >
      <BackgroundImage
        :image="article.image ?? ''"
        :label="article.title ?? ''"
        v-bind="
          titlePosition === 'bottom' ? { animate: true, gradient: true } : {}
        "
      />
     <FavoriteButton v-if="(article as any).takeFiveId"
      :logged-in="userStore.loggedIn"
      :item-type="article.type"
      :is-favorite="isFavorite"
      @toggle="onToggle(article)"
      :id="`fav-${id}`"
      />
      <NuxtLink
        :id="`img-${id}`"
        :aria-label="article.title"
        v-if="titlePosition === 'bottom'"
        :to="article.url ?? ''"
        class="absolute inset-0 bg-black/20 hover:bg-black/40 transition-all p-4 flex flex-col justify-end z-10"
        external
      >
        <div class="absolute bottom-[1rem] flex flex-col items-start">
          <div
            class="bg-gray-900 rounded-[0.4285714286rem] pt-[0.1rem] pb-[0.1rem] pl-[0.6rem] pr-[0.6rem]"
          >
            <Icon icon="newspaper" class="text-green-300 text-lg"  v-if="article.type === 'article'"/>
            <Icon icon="video" class="text-sky text-lg"  v-if="article.type === 'video'"/>
            <Icon icon="podcast" class="text-pink text-lg"  v-if="article.type === 'podcast'"/>
          </div>
        </div>
      </NuxtLink>
    </div>
    <div v-if="titlePosition === 'bottom'">
      <div class="mt-[1.786rem] mb-[1.5rem]">
        <Heading
          :level="5"
          size="Xl"
          class="!text-ash-500 font-medium leading-[1.446rem]"
        >
          <NuxtLink :id="`title-${id}`" :to="article.url ?? ''" external>{{ article.title }}</NuxtLink>
        </Heading> 
      </div>
      <ArticleExcerpt :description="article.excerpt ?? ''" :maxLength="200" />
      <ArticleMeta
        :publishAt="article.publishAt ?? ''"
        :authorName="article.authorName ?? ''"
        :isFeatured="false"
        titlePos='bottom'
      />

      <AudioPlayer
        :id="`audio-player-${id}`"
        v-if="article.type === 'podcast' && article.audioLink"
        class="mt-[0.714rem]"
        :src="article.audioLink"
        color="black"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import ArticleExcerpt from '../../organism/article/excerpt.vue'
import ArticleMeta from '../../organism/article/meta.vue'
import BackgroundImage from '../../atom/backgroundImage.vue'
import Heading from '../../atom/heading.vue'
import Icon from '../../atom/icon.vue'
import AudioPlayer from '../../atom/audioPlayer.vue'
import { useUserStore } from '~/stores/userStore'
import FavoriteButton from '../../atom/FavoriteButton.vue'

const userStore = useUserStore();

export interface Article {
  title?: string | undefined
  url?: string | null
  image?: string | null
  excerpt?: string | null
  meta?: string | null
  publishAt?: string | null
  authorName?: string | null
  type?: 'article' | 'video' | 'podcast' | 'mixed'
  audioLink?: string
  id?:number | string
}

const props = defineProps<{
  article: Article
  titlePosition?: 'top' | 'bottom'
  mediaType ?:'article' | 'podcast' | 'video'
  isFavorite?: boolean
  id?: string
}>();

const titlePosition = computed<'top' | 'bottom'>(() =>
  props.titlePosition === 'top' ? 'top' : 'bottom'
)
const mediaType = computed(() => {
  return props.mediaType ?? 'article'
});

const isFavorite = computed(() => props.isFavorite ?? false)
const emit = defineEmits<{
  (e: 'toggle-favorite', item: any): void
}>()
const onToggle = (item: any) => {
  emit('toggle-favorite', item)
}
</script>
